import { currentSharepointFolderState } from "../../../src/taskpane/redux/models/reduxModels";
import { CurrentFolderPermissionState } from "./currentFolderPermissionState";
import { DirectoryPermissionIdentity } from "./contentManagerDirectoryIdentity";

export const buildCurrentSharepointFolderState = ({
  existingFolderState,
  folderUpdate,
  directoryIdentity,
  directoryRequestKey,
  permissionState,
}: {
  existingFolderState?: currentSharepointFolderState;
  folderUpdate?: Partial<currentSharepointFolderState>;
  directoryIdentity?: DirectoryPermissionIdentity;
  directoryRequestKey?: string;
  permissionState?: CurrentFolderPermissionState;
}): currentSharepointFolderState => {
  const requestKeyChanged = Boolean(
    directoryRequestKey
    && existingFolderState?.directoryRequestKey
    && existingFolderState.directoryRequestKey !== directoryRequestKey
  );
  const hasFolderUpdateSharePointUniqueId = Boolean(folderUpdate && Object.prototype.hasOwnProperty.call(folderUpdate, "sharePointUniqueId"));
  const hasFolderUpdateCanCreateFolder = Boolean(folderUpdate && Object.prototype.hasOwnProperty.call(folderUpdate, "canCreateFolder"));

  const nextState: currentSharepointFolderState = {
    canView: existingFolderState?.canView ?? true,
    ...existingFolderState,
    ...folderUpdate,
  };

  nextState.directoryRequestKey = directoryRequestKey ?? nextState.directoryRequestKey;

  if (requestKeyChanged && !hasFolderUpdateSharePointUniqueId) {
    delete nextState.sharePointUniqueId;
  }

  if (requestKeyChanged && !hasFolderUpdateCanCreateFolder) {
    delete nextState.canCreateFolder;
  }

  if (directoryIdentity?.sharePointListId && !nextState.sharepointListId) {
    nextState.sharepointListId = directoryIdentity.sharePointListId;
  }

  if (permissionState?.resolvedSharePointUniqueId && permissionState.directoryRequestKey === directoryRequestKey) {
    nextState.sharePointUniqueId = permissionState.resolvedSharePointUniqueId;
  }

  if (!directoryIdentity?.key) {
    nextState.permissionStatus = permissionState?.status ?? nextState.permissionStatus ?? "unknown";
    return nextState;
  }

  nextState.permissionIdentityKey = directoryIdentity.key;

  if (
    !permissionState
    || permissionState.identityKey !== directoryIdentity.key
    || (directoryRequestKey && permissionState.directoryRequestKey !== directoryRequestKey)
  ) {
    nextState.permissionStatus = directoryIdentity.isComplete ? "loading" : "unknown";
    nextState.permissionError = undefined;
    delete nextState.userPermissions;
    return nextState;
  }

  nextState.permissionStatus = permissionState.status;

  switch (permissionState.status) {
    case "loaded":
      nextState.userPermissions = permissionState.permissions;
      nextState.permissionError = undefined;
      return nextState;
    case "failed":
      nextState.permissionError = permissionState.errorMessage;
      delete nextState.userPermissions;
      return nextState;
    case "loading":
    case "unknown":
    default:
      nextState.permissionError = undefined;
      delete nextState.userPermissions;
      return nextState;
  }
};
